module.exports = __webpack_public_path__ + "img/logo.e210f94f.png";